var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProductIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.4 5.4C8.04 5.4 7.8 5.76 7.8 6V9H6.6V6C6.6 5.64 6.36 5.4 6 5.4C5.64 5.4 5.4 5.76 5.4 6V9H4.2V6C4.2 5.64 3.96 5.4 3.6 5.4C3.24 5.4 3 5.76 3 6V9.96C3 11.04 3.84 11.88 4.8 12V20.4C4.8 21.12 5.28 21.6 6 21.6C6.72 21.6 7.2 21.12 7.2 20.4V12C8.16 11.88 9 11.04 9 9.96V6C9 5.76 8.76 5.4 8.4 5.4ZM10.8 6V13.2H12V20.4C12 21.12 12.48 21.6 13.2 21.6C13.92 21.6 14.4 21.12 14.4 20.4V2.4C12.36 2.4 10.8 3.96 10.8 6ZM19.2 4.8C17.52 4.8 16.2 6.6 16.2 8.76C16.08 10.2 16.8 11.52 18 12.36V20.4C18 21.12 18.48 21.6 19.2 21.6C19.92 21.6 20.4 21.12 20.4 20.4V12.36C21.6 11.52 22.32 10.2 22.2 8.76C22.2 6.6 20.88 4.8 19.2 4.8Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductIcon);
export default __webpack_public_path__ + "static/media/product_icon.ffe2908691f52cc77840c130fbdc83f0.svg";
export { ForwardRef as ReactComponent };